import LogoList from './LogoList'

export default LogoList
